/**
 *  @class
 *  @function CartDrawerUpsell
 */

class CartDrawerUpsell {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.cart-drawer-upsell-track');
    this.prev = el.querySelector('.cart-drawer-upsell-arrow-prev');
    this.next = el.querySelector('.cart-drawer-upsell-arrow-next');

    if (!this.track || !this.prev || !this.next) {
      return;
    }

    this.prev.addEventListener('click', () => this.scroll(-1));
    this.next.addEventListener('click', () => this.scroll(1));
    this.track.addEventListener('scroll', this.updateArrows.bind(this));
    this.updateArrows();
  }
  scroll(direction) {
    let card = this.track.querySelector('.cart-drawer-upsell-card');
    let amount = card ? card.getBoundingClientRect().width + 15 : this.track.clientWidth;
    this.track.scrollBy({
      left: amount * direction,
      behavior: 'smooth'
    });
  }
  updateArrows() {
    let maxScroll = this.track.scrollWidth - this.track.clientWidth;
    this.prev.disabled = this.track.scrollLeft <= 0;
    this.next.disabled = this.track.scrollLeft >= maxScroll - 1;
  }
}

function initCartDrawerUpsells() {
  document.querySelectorAll('.cart-drawer-upsell').forEach((el) => {
    if (!el.dataset.upsellInit) {
      el.dataset.upsellInit = 'true';
      new CartDrawerUpsell(el);
    }
  });
}

initCartDrawerUpsells();
document.addEventListener('cart-drawer:open', initCartDrawerUpsells);
